module.exports = __webpack_public_path__ + "static/media/mountain6.24405f2e.jpg";